<f-data-card class="pos-relative">
  <!-- Based on inbound call/outbound call need to show only one heading -->
  <div class="card-header">
    <h5>About the Interaction</h5>


    <button mat-button1 color="primary" class="show-hide" id="toggle-1"
      (click)="rootScope.activeCustTab.showContent = !rootScope.activeCustTab.showContent">
      <span *ngIf="!rootScope.activeCustTab.showContent"><f-icon icon-config='{"iconName": "angle-down", "iconType": "light", "iconSize": "s"}'></f-icon></span>
      <span *ngIf="rootScope.activeCustTab.showContent"><f-icon icon-config='{"iconName": "angle-up", "iconType": "light", "iconSize": "s"}'></f-icon></span>
    </button>
  </div>

  <div class="about-interaction show-hide-data" *ngIf="rootScope.activeCustTab.showContent">
    <section *ngIf="rootScope.customerTypeAPIFailure" class="error-wrapper">
      <f-alert variant="error">
        {{errorMsg}}
        <button (click)="apiService.getCustomerTypesAPI()" class="btn-alert">Try again</button>
      </f-alert>
    </section>
    <!-- Success msg for Biometrics starts -->
    <div class="error-wrapper " *ngIf="rootScope.activeCustTab.biometricData.biometricCompleted && rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel4" >
      <f-alert variant="success">Success! This customer is fully secured for this line of business.</f-alert>
    </div>
    <!-- Success msg for Biometrics ends -->
     
    <div class="error-wrapper" *ngIf="cusAccService.authSucessMsg()">
      <f-alert variant="success">{{validationSuccessMessage}}</f-alert>
    </div>
    <div class="error-wrapper"
      *ngIf="rootScope.isLiveCall&&rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel4 && rootScope.activeCustTab?.pinEntryApp?.pinValidMsg && !rootScope.activeCustTab?.genesysAttributes?.CP_INDICATIVE_DATA_SECURED">
      <f-alert variant="success">{{pinEntrySuccessMessage}}</f-alert>
    </div>
    <div class="error-wrapper"
      *ngIf="rootScope.isLiveCall&&rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel4 && rootScope.activeCustTab?.otcData?.validateOtcSuccess">
      <f-alert variant="success">{{otcValidateSuccessMessage}}</f-alert>
    </div>
    <div class="error-wrapper" *ngIf="cusAccService.clearSuccessMsg()">
      <f-alert variant="success">{{rootScope.activeCustTab.isEIVSelected ? EIV_MSG : clearVerificationSuccessMessage}}</f-alert>
    </div>
    <div class="error-wrapper" *ngIf="rootScope.activeCustTab.privacyPolicyData?.sendSuccess">
      <f-alert variant="success">{{privacyPolicySendSuccessMessage}}</f-alert>
    </div>

    <div class="auth-card">
      <div class="card-row">
        <div class="card-left">
          <h6>Authentication Status</h6>
        </div>

        <div class="card-right">
          <p class="auth-status">
            <span [ngClass]="
                cusAccService.identifyAuthenticateClass(
                  rootScope.activeCustTab.authenticateStatus
                )
              "></span>

            {{ rootScope.activeCustTab.authenticateStatus }}
          </p>

          <p *ngIf="rootScope.activeCustTab?.genesysAttributes?.CS_AUTH_CD && rootScope.activeCustTab?.channel === channel.call && rootScope.activeCustTab.CS_SECURITY_LEVEL==='4' "
            class="font-normal auth-method">{{getMethodName()}}  </p>

        </div>
      </div>
      <div class="card-row">

        <div class="card-left">
          <p>Who is it?</p>

          <!--label (Caller/Customer Type) name change for CCR1-5039-->
          <app-alight-drop-down [group]="rootScope.customerTypeForm" [controlName]="'customerType'" [required]="false"
            description="fieldValueDescription" [disable]="cusAccService.callerTypeValidation()"
            label="Caller/Customer Type" [value]="'fieldValue'" [list]="rootScope.customerTypeData"
            (changeEvent)="changeCustomerType($event)">
          </app-alight-drop-down>
        </div>
        <div class="card-right">
          <f-button *ngIf="
              (rootScope.activeCustTab?.activeCall ||
                rootScope.activeCustTab?.activeChat) &&
              !rootScope.activeCustTab.additionalAccount
            " (click)="goToAuthenticatePage()" [iconConfig]="iconConfig" class="hide1" text="View authentication"
            title="View authentication" type="button" variant="action"></f-button>
        </div>
      </div>
    </div>
    <div class="row-divider"></div>
    <div class="interaction-card">
      <div class="card-row">
        <div class="card-left">
          <h6>Interaction Status</h6>
        </div>
        <div class="card-right">
          <!-- when call is active  -->
          <p class="call-status" *ngIf="
              rootScope.activeCustTab.activeCall ||
              rootScope.activeCustTab.activeChat
            ">
            <span *ngIf="
                rootScope.activeCustTab.iconClass === 'red' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'call')
              ">
              <!-- <i class="fa-solid fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i> -->
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 's'}"></f-icon>



            </span>
            <span *ngIf="
            rootScope.activeCustTab.iconClass === 'light' &&
            rootScope.activeCustTab.active &&
            liveIcon(rootScope.activeCustTab, 'call')
          ">
              <!-- <i class="fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i> -->
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 's'}"></f-icon>

            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass === 'green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'call')
              ">
              <!-- <i class="fa-solid fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i> -->
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'solid', iconSize: 's'}"></f-icon>
            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass === 'solid green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'chat')
              ">
              <!-- <i class="fa-solid fa-comment" [ngClass]="rootScope.activeCustTab.iconClass"></i> -->
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'solid', iconSize: 's'}"></f-icon>
            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass !== 'solid green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'chat')
              ">
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 's'}"></f-icon>
            </span>
            <span> {{ getInteractionStatus() }}</span>
          </p>

          <!-- In researche mode below text will be visible  -->
          <p class="auth-status"
            *ngIf="!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.activeChat &&  !this.isConversationIdPresent()">
            <span class=""></span> {{ getInteractionStatus() }}
          </p>

          <!----When call/Chat gets disconnected -->
          <p class="auth-status disconnect"
            *ngIf="!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.activeChat && this.isConversationIdPresent()">
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.call  && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL===securityLevel4">
              <!-- <i class="fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i> -->
               <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 's'}"></f-icon>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.call  && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL!==securityLevel4">
              <!-- <i class="fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i> -->
               <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 's'}"></f-icon>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.call  && !rootScope.activeCustTab.interactionDisconnected">
              <!-- <i class="fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i> -->
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'phone', iconType: 'light', iconSize: 's'}"></f-icon>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.chat && !rootScope.activeCustTab.interactionDisconnected">
              <f-icon [ngClass]="rootScope.activeCustTab.iconClass" [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 's'}"></f-icon>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.chat && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL==='4'">
              <f-icon [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 's', iconColor: 'green'}"></f-icon>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel === channel.chat && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL==='1'">
              <f-icon [iconConfig]="{iconName: 'comment', iconType: 'light', iconSize: 's', iconColor: 'red'}"></f-icon>
            </span>
            {{ getInteractionStatus() }}

          </p>
        </div>
      </div>
      <div class="card-row">
        <div class="card-left">
          <p>What role?</p>
          <form [formGroup]="form">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Role Type</mat-label>
              <mat-select disableRipple disableOptionCentering (focusout)="onRoleChangeFocusOut($event)"
                (keydown)="onKeyBoardRoleChange($event)" name='role' disableRipple formControlName="roleType"
                disableOptionCentering [(ngModel)]="defaultRole" (selectionChange)="onRoleChange($event)"
                (mouseenter)="clicked($event)" [disabled]='cusAccService.roleTypeValidation()'>
                <mat-option *ngFor="let roletype of cusAccService?.activeTabDt?.roleTypeList"
                  [value]="roletype.roleName" [title]="roletype.roleName">
                  {{ roletype.roleName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="card-right" *ngIf="((rootScope.indicatorClass === 'green'||rootScope.simulationData?.isSimulationModeActive) && ( !rootScope.activeCustTab.activeCall &&
        !rootScope.activeCustTab.activeChat &&
        !isConversationIdPresent()))">

          <f-button text="Call this customer" title="Call this customer" type="button" variant="progressive" disabled="false"
            (click)="triggerOutboundCall()"></f-button>
        </div>
      </div>
    </div>
  </div>

  <app-card-loader class="hide"></app-card-loader>

  <app-loader *ngIf="rootScope.custAccInteractionLoader || cusAccService.firstLoadLoader" [loaderType]="loaderType"
    [loaderMsg]="rootScope.showCustAccInteractionLoaderMsg"></app-loader>
</f-data-card>